export enum TICKET_STATE {
  OPEN = 1,
  PAUSED = 2,
  RESOLVED = 3,
  CLOSED = 4,
}

export const TicketStateString = {
  [TICKET_STATE.OPEN]: 'Abierto',
  [TICKET_STATE.PAUSED]: 'Pausado',
  [TICKET_STATE.RESOLVED]: 'Resuelto',
  [TICKET_STATE.CLOSED]: 'Cerrado',
};

export enum TICKET_PRIORITY {
  CRITICO = 1,
  ALTA = 2,
  NORMAL = 3,
  BAJA = 4,
  MUY_BAJA = 5,
}

export const TicketPriorityString = {
  [TICKET_PRIORITY.CRITICO]: 'Crítico',
  [TICKET_PRIORITY.ALTA]: 'Alta',
  [TICKET_PRIORITY.NORMAL]: 'Normal',
  [TICKET_PRIORITY.BAJA]: 'Baja',
  [TICKET_PRIORITY.MUY_BAJA]: 'Muy baja',
};

export enum TICKET_CONTACT_TYPE {
  REACTIVO = 1,
  PROACTIVO = 2,
}

export const TicketContactTypeString = {
  [TICKET_CONTACT_TYPE.REACTIVO]: 'Reactivo',
  [TICKET_CONTACT_TYPE.PROACTIVO]: 'Proactivo',
};

export enum TICKET_LOGISTIC_STATE {
  /**
   * No tiene paquetes asociados (ni envíos ni recepciones)
   */
  SIN_GESTION_LOGISTICA = 0,
  /**
   * Todos sus paquetes están en estado PENDIENTE
   */
  PENDIENTE = 1,
  /**
   * Al menos uno de sus paquetes está en un estado distinto a PENDIENTE
   */
  EN_CURSO = 2,
  /**
   * Todos sus paquetes están en estado FINALIZADO y todos los ITEM PAQUETES tienen asignada una resolución.
   * Este último caso debería contemplar que si la resolución es FACTURADO deba incluir el número de factura
   */
  LISTO_PARA_RESOLVER = 3,
  /**
   * Todos sus paquetes están en estado FINALIZADO pero al menos un ITEM PAQUETE no tiene asignada una resolución
   * o la resolución es FACTURADO pero no tiene número de factura asignado.
   */
  FINALIZADO = 4,
  CANCELADO = 5,
}

export const TicketLogisticStateString = {
  [TICKET_LOGISTIC_STATE.SIN_GESTION_LOGISTICA]: 'Sin gestión logística',
  [TICKET_LOGISTIC_STATE.PENDIENTE]: 'Pendiente',
  [TICKET_LOGISTIC_STATE.EN_CURSO]: 'En curso',
  [TICKET_LOGISTIC_STATE.LISTO_PARA_RESOLVER]: 'Listo para resolver',
  [TICKET_LOGISTIC_STATE.FINALIZADO]: 'Finalizado',
  [TICKET_LOGISTIC_STATE.CANCELADO]: 'Cancelado',
};

/**
 * Razones de complejidad seleccionables en la encuesta al resolver un ticket.
 */
export enum TICKET_COMPLEXITY_REASON {
  UNEXPECTED_FAILURE = 'unexpected-failure',
  HARDWARE_SUPPORT = 'hardware-support',
  SOFTWARE_SUPPORT = 'software-support',
  COWORKER_SUPPORT = 'coworker-support',
  INTERNAL_INTERACTIONS = 'internal-interactions',
  CLIENT_INTERACTIONS = 'client-interactions',
  TIRING_CLIENT = 'tiring-client',
  CONNECTIVITY = 'connectivity',
  TECHNICIAN_NO_RESPONSE = 'technician-no-response',
  NO_PROCESS = 'no-process',
  OTHER = 'other',
}

export const TicketComplexityReasonLabels: Record<TICKET_COMPLEXITY_REASON, string> = {
  [TICKET_COMPLEXITY_REASON.UNEXPECTED_FAILURE]: 'Falló algo que no tenía que fallar (imprevisto)',
  [TICKET_COMPLEXITY_REASON.HARDWARE_SUPPORT]: 'Necesité acompañamiento de hardware',
  [TICKET_COMPLEXITY_REASON.SOFTWARE_SUPPORT]: 'Necesité acompañamiento de software',
  [TICKET_COMPLEXITY_REASON.COWORKER_SUPPORT]:
    'Necesité acompañamiento de compañeros, falta de información',
  [TICKET_COMPLEXITY_REASON.INTERNAL_INTERACTIONS]:
    'Necesité muchas interacciones internas con Operaciones y/o Administración',
  [TICKET_COMPLEXITY_REASON.CLIENT_INTERACTIONS]: 'Necesité muchas interacciones con el cliente',
  [TICKET_COMPLEXITY_REASON.TIRING_CLIENT]:
    'La interacción con el cliente fue desgastante (el cliente no respondía, tuve que insistir mucho)',
  [TICKET_COMPLEXITY_REASON.CONNECTIVITY]: 'Problemas de conectividad del técnico',
  [TICKET_COMPLEXITY_REASON.TECHNICIAN_NO_RESPONSE]: 'Falta de respuesta del técnico',
  [TICKET_COMPLEXITY_REASON.NO_PROCESS]:
    'No existe un proceso o criterios claros para solucionar este problema en particular',
  [TICKET_COMPLEXITY_REASON.OTHER]: 'Otros',
};
